import type { AgencyLink } from '@/services/ws-orders/src/main/resources/rest-api';

import { APPROVALS, DRAFTS, RUNNING } from 'src/constants.ts';
import { PositionsType } from './types.ts';

const isShownStatus = (status: AgencyLink): boolean => status.name !== DRAFTS && status.name !== APPROVALS;

const getLinksByPositionsType = (links: AgencyLink[], positionsType: PositionsType): AgencyLink[] =>
  positionsType === PositionsType.PRINT ? links.filter((status) => status.name !== RUNNING) : links;

export const getStatuses = (links: AgencyLink[] | undefined, positionsType: PositionsType): string[] => {
  if (!links?.length) {
    return [];
  }

  return getLinksByPositionsType(links.filter(isShownStatus), positionsType).map((link) => link.name);
};
